import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { Card, CardContent } from './Card';
import { CheckCircle2 } from 'lucide-react';
export function DeliverablesSection() {
  const deliverables = [{
    title: 'El Manual Digital',
    desc: 'Mente en Blanco en 5 Minutos (PDF de implementación rápida).'
  }, {
    title: 'El Sistema P.A.U.',
    desc: 'Los 3 pasos exactos para vaciar tu memoria de trabajo antes de tocar la almohada.'
  }, {
    title: 'Guía de Categorización de Amenazas',
    desc: 'Cómo desarmar preocupaciones abstractas sobre el futuro.'
  }, {
    title: 'El Ritual de Cierre de Sesión Cerebral',
    desc: 'La técnica física para indicarle a tu cuerpo que la jornada mental terminó.'
  }, {
    title: 'Plantilla de Vaciado Nocturno',
    desc: 'Lista para imprimir o replicar en cualquier libreta.'
  }];
  return <section className="py-24 bg-stone-950 px-4 sm:px-6 lg:px-8" data-id="element-34">
      <div className="max-w-4xl mx-auto" data-id="element-35">
        <FadeIn className="text-center mb-16" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-37">
            Lo que obtienes hoy
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-38">
          {deliverables.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-39">
              <Card className="bg-stone-900 border-stone-800 hover:border-amber-500/50 transition-colors" data-id="element-40">
                <CardContent className="p-6 flex items-start sm:items-center gap-4" data-id="element-41">
                  <CheckCircle2 className="w-6 h-6 text-amber-500 shrink-0 mt-1 sm:mt-0" data-id="element-42" />
                  <div data-id="element-43">
                    <h3 className="text-lg font-semibold text-white mb-1" data-id="element-44">
                      {item.title}
                    </h3>
                    <p className="text-stone-400" data-id="element-45">{item.desc}</p>
                  </div>
                </CardContent>
              </Card>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}